import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { IoDiamondSharp } from "react-icons/io5";
import CustomAvatar from "../../../VuexyCompo/avatar/index";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { GiStoneSphere } from "react-icons/gi";
import { GiMetalBar } from "react-icons/gi";
import "./RowMaterial.scss";
import productionImg from "../../../Assets/production.png";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { homeRawMaterialData } from "../../../Recoil/atom";

const RowMaterial = () => {
  
  const [rowMaterialData, setRowMaterialData] = useRecoilState(homeRawMaterialData);
  useEffect(() => {
    const storedSaleData = sessionStorage.getItem("Production");
    if (storedSaleData) {
      setRowMaterialData(JSON.parse(storedSaleData));
    }
  }, []);

  return (
    <div>
      <div style={{ margin: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            gap: "20px",
          }}
        >
          <div
            className="roe_materal_production"
            style={{ padding: "10px", width: "100%", marginBottom: "10px" }}
          >
            <p className="rowmaterial_wip_title">Work in progress</p>
            <div style={{ display: "flex", padding: "0px", width: "100%" }}>
              <CardContent
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
                className="rowmaterial_box"
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div>
                    <img src={productionImg} className="production_img" />
                  </div>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <p className="rowmaterial_box_title"></p>
                    <p className="rowmaterial_box_value">Production</p>
                    <Typography
                      variant="body2"
                      style={{
                        color: "#fca148",
                        fontWeight: 600,
                        fontSize: "20px",
                      }}
                    >
                      {rowMaterialData?.WIPCount}{" "}
                      <span style={{ fontSize: "15px" }}>Jobs</span>
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            gap: "20px",
          }}
        >
          <div
            className="roe_materal_production"
            style={{ padding: "10px", width: "100%" }}
          >
            <p className="rowmaterial_wip_row_title">Raw Material</p>
            <div style={{ display: "flex", padding: "0px", width: "100%" }}>
              <CardContent style={{ width: "50%" }} className="rowmaterial_box">
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <CustomAvatar skin="light" color="warning">
                    <IoDiamondSharp />
                  </CustomAvatar>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <p className="rowmaterial_box_value">
                      {rowMaterialData?.DiamondWt}
                    </p>
                    <p className="rowmaterial_title">DIAMOND</p>
                  </Box>
                </Box>
              </CardContent>
              <CardContent style={{ width: "50%" }} className="rowmaterial_box">
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <CustomAvatar skin="light" color="error">
                    <GiMetalBar />
                  </CustomAvatar>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <p className="rowmaterial_box_value">
                      {rowMaterialData?.MetalWt}
                    </p>
                    <p className="rowmaterial_title">METAL</p>
                  </Box>
                </Box>
              </CardContent>
            </div>
            <div style={{ display: "flex", padding: "0px", width: "100%" }}>
              <CardContent style={{ width: "50%" }} className="rowmaterial_box">
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <CustomAvatar skin="light" color="success">
                    <GiStoneSphere />
                  </CustomAvatar>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <p className="rowmaterial_box_value">
                      {rowMaterialData?.CSWt}
                    </p>
                    <p className="rowmaterial_title">STONE</p>
                  </Box>
                </Box>
              </CardContent>
              <CardContent style={{ width: "50%" }} className="rowmaterial_box">
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <CustomAvatar skin="light" color="primary">
                    <MdOutlineMiscellaneousServices />
                  </CustomAvatar>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <p className="rowmaterial_box_value">
                      {rowMaterialData?.MiscWt}
                    </p>
                    <p className="rowmaterial_title">MISC</p>
                  </Box>
                </Box>
              </CardContent>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowMaterial;
